"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "warning*"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector",
    d: "M24.0002 43.2002C27.7976 43.2002 31.5097 42.0741 34.6671 39.9644C37.8246 37.8547 40.2855 34.8561 41.7387 31.3477C43.1919 27.8394 43.5721 23.9789 42.8313 20.2545C42.0904 16.53 40.2618 13.1089 37.5766 10.4237C34.8915 7.73858 31.4704 5.90996 27.7459 5.16912C24.0215 4.42829 20.161 4.80851 16.6527 6.26171C13.1443 7.71491 10.1457 10.1758 8.03598 13.3332C5.92626 16.4907 4.8002 20.2028 4.8002 24.0002C4.80594 29.0906 6.83064 33.9708 10.4301 37.5703C14.0295 41.1698 18.9098 43.1944 24.0002 43.2002ZM25.4771 32.8617C25.4771 33.2534 25.3215 33.6291 25.0445 33.9061C24.7676 34.1831 24.3919 34.3387 24.0002 34.3387C23.6085 34.3387 23.2328 34.1831 22.9558 33.9061C22.6789 33.6291 22.5233 33.2534 22.5233 32.8617L22.5233 22.5233C22.5233 22.1316 22.6789 21.7559 22.9558 21.4789C23.2328 21.202 23.6085 21.0464 24.0002 21.0464C24.3919 21.0464 24.7676 21.202 25.0445 21.4789C25.3215 21.7559 25.4771 22.1316 25.4771 22.5233L25.4771 32.8617ZM24.0002 13.6617C24.4384 13.6617 24.8667 13.7917 25.231 14.0351C25.5953 14.2785 25.8793 14.6245 26.0469 15.0293C26.2146 15.4341 26.2585 15.8796 26.173 16.3093C26.0875 16.7391 25.8765 17.1338 25.5667 17.4436C25.2569 17.7535 24.8621 17.9645 24.4324 18.0499C24.0026 18.1354 23.5572 18.0915 23.1524 17.9239C22.7476 17.7562 22.4016 17.4722 22.1582 17.1079C21.9147 16.7436 21.7848 16.3153 21.7848 15.8771C21.7848 15.2896 22.0182 14.7261 22.4337 14.3106C22.8491 13.8951 23.4126 13.6617 24.0002 13.6617Z",
    fill: fill
  })));
};

exports["default"] = _default;